import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const LoginStaffPortal = () => {
  // ----- change these to whatever static credentials you want -----
  const STATIC_USERNAME = "staff";
  const STATIC_PASSWORD = "ric2025";
  // ----------------------------------------------------------------

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // If already logged in, redirect immediately
  useEffect(() => {
    const ok = sessionStorage.getItem("staff_portal_authed");
    if (ok === "1") navigate("/mark-attendance");
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password) {
      Swal.fire({ icon: "warning", title: "Missing fields", text: "Enter username and password." });
      return;
    }

    setLoading(true);
    try {
      // Simulate small delay for UX
      await new Promise((r) => setTimeout(r, 400));

      if (username.trim() === STATIC_USERNAME && password === STATIC_PASSWORD) {
        sessionStorage.setItem("staff_portal_authed", "1");
        Swal.fire({
          icon: "success",
          title: "Welcome",
          text: "Access granted. Redirecting to attendance...",
          showConfirmButton: false,
          timer: 900,
          background: "#fff",
        });
        setTimeout(() => navigate("/mark-attendance"), 900);
      } else {
        Swal.fire({ icon: "error", title: "Access Denied", text: "Invalid username or password." });
      }
    } catch (err) {
      console.error(err);
      Swal.fire({ icon: "error", title: "Error", text: "Login failed — try again." });
    } finally {
      setLoading(false);
    }
  };

  const handleLogoutClear = () => {
    sessionStorage.removeItem("staff_portal_authed");
    setUsername("");
    setPassword("");
    Swal.fire({ icon: "info", title: "Cleared", text: "Login cleared." });
  };

  return (
    <div
      className="min-vh-100 d-flex align-items-center justify-content-center"
      style={{
        background: "linear-gradient(135deg, #f3f6ff 0%, #e3f2fd 50%, #f3e5f5 100%)",
        padding: "40px",
      }}
    >
      <div
        className="card shadow-lg p-4 rounded-4"
        style={{
          width: "100%",
          maxWidth: "520px",
          background: "rgba(255,255,255,0.98)",
          border: "1px solid rgba(0,0,0,0.04)",
        }}
      >
        {/* Header */}
        <div className="text-center mb-3">
          <img
            src="/assets/img/logo/new-logo.png"
            alt="Hospital Logo"
            style={{ width: 84, height: 84, objectFit: "contain", borderRadius: 12, boxShadow: "0 6px 18px rgba(0,0,0,0.08)" }}
          />
          <h3 className="mt-3 mb-0" style={{ color: "#0b5ed7", fontWeight: 700 }}>
            Login — Staff Attendance Portal
          </h3>
          <p className="text-muted small mb-0">Rawalpindi Institute of Cardiology — Internal</p>
        </div>

        {/* Form */}
        <form onSubmit={handleLogin} className="mt-4">
          <div className="mb-3">
            <label className="form-label fw-semibold">Username</label>
            <input
              type="text"
              className="form-control shadow-sm"
              placeholder="Enter username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoFocus
            />
          </div>

          <div className="mb-3 position-relative">
            <label className="form-label fw-semibold">Password</label>
            <div style={{ display: "flex", gap: 8 }}>
              <input
                type={showPass ? "text" : "password"}
                className="form-control shadow-sm"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => setShowPass((s) => !s)}
                aria-label="Toggle password visibility"
                style={{ whiteSpace: "nowrap" }}
              >
                {showPass ? "Hide" : "Show"}
              </button>
            </div>
          </div>

          <div className="d-flex justify-content-between align-items-center mb-3">
            <div>
              <small className="text-muted">Use hospital network or localhost for access</small>
            </div>
            <div>
              <button
                type="button"
                className="btn btn-sm btn-link text-decoration-none"
                onClick={handleLogoutClear}
                title="Clear session"
                style={{ color: "#6c757d" }}
              >
                Clear
              </button>
            </div>
          </div>

          <div className="d-grid">
            <button
              type="submit"
              className="btn btn-primary btn-lg rounded-pill"
              disabled={loading}
              style={{ background: "linear-gradient(90deg,#007bff,#00b4d8)", border: "none", boxShadow: "0 6px 18px rgba(11,93,255,0.12)" }}
            >
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </div>
        </form>

        {/* Footer small */}
        <div className="text-center mt-4">
          <small className="text-muted">
            Contact IT if you cannot access — portal restricted to hospital network.
          </small>
        </div>

        {/* Inline minimal styles */}
        <style>{`
          .card { border-radius: 14px; }
          .form-control { border-radius: 10px; height:44px; }
          .btn-primary { height:48px; font-weight:600; }
          @media (max-width: 575px) {
            .card { padding: 18px; }
            .form-control { height:42px; }
          }
        `}</style>
      </div>
    </div>
  );
};

export default LoginStaffPortal;
